import { createTRPCContext } from '@trpc/tanstack-react-query';

import type { AppRouter } from '~/server/trpc/routers';

// const appRouter = t.router({
//   user: t.procedure.query(() => {
//     return { name: 'John Doe', age: 30 };
//   }),
// });
// type AppRouter = typeof appRouter;

export const { TRPCProvider, useTRPC, useTRPCClient } =
  createTRPCContext<AppRouter>();
